import { readFile } from 'node:fs/promises';
import { join } from 'node:path';

export const DEFAULT_IGNORE_PATTERNS = [
  'node_modules',
  '.git',
  'dist',
  'build',
  '.next',
  '.turbo',
  'coverage',
  '.cache',
];

function normalize(value: string): string {
  return value.replace(/\\/g, '/').replace(/^\/+/, '').replace(/\/+$/, '');
}

export async function loadIgnoreRules(workspaceRoot: string): Promise<string[]> {
  const rules = new Set(DEFAULT_IGNORE_PATTERNS);
  try {
    const content = await readFile(join(workspaceRoot, '.gitignore'), 'utf8');
    for (const raw of content.split(/\r?\n/)) {
      const line = raw.trim();
      if (!line || line.startsWith('#') || line.startsWith('!')) continue;
      rules.add(normalize(line));
    }
  } catch {
    // Missing .gitignore is fine.
  }
  return [...rules].filter(Boolean);
}

export function createIgnoreMatcher(patterns: readonly string[]) {
  const normalized = patterns.map(normalize).filter(Boolean);
  return (relativePath: string): boolean => {
    const rel = normalize(relativePath);
    const parts = rel.split('/');
    return normalized.some((pattern) => {
      const clean = pattern.replace(/^\*\//, '');
      if (clean.includes('*')) {
        const regex = new RegExp(`^${clean.replace(/[.+?^${}()|[\]\\]/g, '\\$&').replace(/\*/g, '.*')}$`);
        return regex.test(rel) || parts.some((part) => regex.test(part));
      }
      return rel === clean || rel.startsWith(`${clean}/`) || parts.includes(clean);
    });
  };
}

